module.exports = __webpack_public_path__ + "img/wifi-network-in-home.f1ee325e.jpg";